/* global config:true */
/* eslint-disable no-process-env, eqeqeq, no-eq-null */

config = {};

const { REACT_APP_ENV } = process.env;

const auth0Default = {
  scope: 'openid profile email phone offline_access',
  audience: 'https://api.icims.com/v1/',
};

const token =
  'ZaVnC4dhaV0EXwSqLzlbN9m8jqR5g27gQbzwSWWGT13TowVYzIf78gWMVb5PfUtj8gORlPvM7ylps5qMjTgo_s2DGfdOpIp1PEyAD-PvJ2vegzSmcZOUTQ==';

config.auth0 = {
  scope: auth0Default.scope,
  audience: auth0Default.audience,
  US: { clientId: 'zF6TP6VVKVjYMAsg2QVpcxTX0trzL8fF', domain: 'login-dev.icimsmco.net' },
  CA: { clientId: 'TODO', domain: 'TODO' },
  EU: { clientId: 'TODO', domain: 'TODO' },
};

config.sumo = {
  token,
  sourceCategory: 'dev/textrecruit/web-react',
};

config.sumo = {
  token,
  sourceCategory: 'dev/textrecruit/web-react',
};

if (REACT_APP_ENV === 'dev') {
  config.envShortName = 'dev';
  config.apiRootUrl = 'https://staging1.textrecruit.com/api/';
  config.lookupApiUrl = 'https://lookup.dev.textrecruit.tools';
  config.realTimeUrl = 'wss://rt-aws-us.dev.textrecruit.tools/ws';
  config.launchDarklyId = '5b4e60dbc4ea4f2d74b18062';
} else if (REACT_APP_ENV === 'stg') {
  config.envShortName = 'stg';
  config.lookupApiUrl = 'https://lookup.stg.textrecruit.tools';
  config.apiRootUrl = 'https://test1.textrecruit.com/api/';
  config.realTimeUrl = 'wss://rt-aws-us.stg.textrecruit.tools/ws';
  config.launchDarklyId = '5b4dde4a4892e62d90d9f3c9';
  config.sumo = {
    token,
    sourceCategory: 'stg/textrecruit/web-react',
  };
  config.auth0 = {
    scope: auth0Default.scope,
    audience: auth0Default.audience,
    US: { clientId: 'YUwOVwwS0A4XxQNFuUJG8hDLO4ziYaWK', domain: 'login-stg.icimsmco.net' },
    CA: { clientId: 'TODO', domain: 'TODO' },
    EU: { clientId: 'TODO', domain: 'TODO' },
  };
} else if (REACT_APP_ENV === 'prd') {
  config.envShortName = 'prd';
  config.lookupApiUrl = 'https://lookup.prd.textrecruit.tools';
  config.apiRootUrl = 'https://app1.textrecruit.com/api/';
  config.euApiRootUrl = 'https://api-aws-eu.prd.textrecruit.tools/api/';
  config.realTimeUrl = 'wss://rt-aws-us.prd.textrecruit.tools/ws';
  config.euRealTimeUrl = 'wss://rt-aws-eu.prd.textrecruit.tools/ws';
  config.launchDarklyId = '5b4dde4a4892e62d90d9f3ca';
  config.sumo = {
    token:
      'ZaVnC4dhaV2TJr1bgE--IAGcUexNGP7eWTKl_-v1RzEkIAr6NB8xFN0NQ7idh6ZorHlHbLr-cbsGTFgeVTd81FTAlzRAmQwlVWWC4Bs57MLiy-DSkJWjTg==',
    sourceCategory: 'prd/textrecruit/web-react',
  };
  config.auth0 = {
    scope: auth0Default.scope,
    audience: auth0Default.audience,
    US: { clientId: 'w55IY3wUi3Wq5IUVhLzYNayYtEDxwXpH', domain: 'login.icims.com' },
    CA: { clientId: 'PINHKolBl1G7lOfIgTxEdZLLQdcIARpw', domain: 'login.icims.ca' },
    EU: { clientId: 'ThOlRtLSrEHGgiijnJj0YSfe3afU2h5l', domain: 'login.icims.eu' },
  };
} else if (REACT_APP_ENV === 'local') {
  config.envShortName = 'local';
  config.lookupApiUrl = 'http://localhost:8094';
  config.apiRootUrl = 'http://localhost:8081/api/';
  config.realTimeUrl = 'ws://0.0.0.0:9019/ws';
  config.launchDarklyId = '5b4e60dbc4ea4f2d74b18062';
}

config.imageBaseUrl = 'https://app.textrecruit.com/img';
config.clientVersion = '2.0.1';

module.exports = config;
